"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Raycast = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
var Raycast = /** @class */ (function () {
    function Raycast(domElement, scene, camera, onIntersections) {
        var _this = this;
        this.domElement = domElement;
        this.scene = scene;
        this.camera = camera;
        this.onIntersections = onIntersections;
        this.pointer = new realms_three_1.default.Vector2();
        /**
         * Makes a raycast and checks for intersections
         */
        this.raycast = function (_a) {
            var _b = _a === void 0 ? {} : _a, objects = _b.objects, _c = _b.recursive, recursive = _c === void 0 ? true : _c;
            if (!_this.scene || !_this.camera) {
                return;
            }
            var rayCaster = new realms_three_1.default.Raycaster();
            rayCaster.setFromCamera(_this.pointer, _this.camera);
            var targets = objects !== null && objects !== void 0 ? objects : _this.scene.children;
            var target = targets[0];
            var intersects = targets.length === 1 && target
                ? rayCaster.intersectObject(target)
                : rayCaster.intersectObjects(targets, recursive);
            _this.onIntersections(intersects);
        };
        this.onMouseMove = function (mouseEvent) {
            if (!_this.domElement) {
                return;
            }
            var bbox = _this.domElement.getBoundingClientRect();
            _this.pointer.x = ((mouseEvent.clientX - bbox.left) / bbox.width) * 2 - 1;
            _this.pointer.y = -((mouseEvent.clientY - bbox.top) / bbox.height) * 2 + 1;
        };
    }
    Raycast.prototype.subscribe = function () {
        var _a;
        (_a = this.domElement) === null || _a === void 0 ? void 0 : _a.addEventListener("mousemove", this.onMouseMove);
    };
    Raycast.prototype.unsubscribe = function () {
        var _a;
        (_a = this.domElement) === null || _a === void 0 ? void 0 : _a.removeEventListener("mousemove", this.onMouseMove);
    };
    Raycast.prototype.getPointer = function () {
        return {
            x: this.pointer.x,
            y: this.pointer.y,
        };
    };
    return Raycast;
}());
exports.Raycast = Raycast;
